import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/context/authContext";
import { addMembership, removeMembership } from "@/Services/institutions.service";

export function useInstitutionMembershipMutations(institutionId: string) {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: ["institution-memberships", institutionId] });

  async function add(params: {
    ministerId?: string | null;
    institutionMemberId?: string | null;
  }) {
    if (!user) throw new Error("Not authenticated");
    await addMembership({ ...params, institutionId, userId: user.id });
    await invalidate();
  }

  async function remove(membershipId: string, leftAt: string, notes: string | null) {
    if (!user) throw new Error("Not authenticated");
    await removeMembership(membershipId, leftAt, notes, user.id);
    await invalidate();
  }

  return { add, remove };
}
